import { forEach } from '@angular/router/src/utils/collection';
import { AmberApi } from 'app/core/models/api-helpers';
import { Component, OnInit, ViewChild, Type } from '@angular/core';
import { RxComponent } from 'app/core/components/common/rx.component';
import { TreeComponent, TreeNode } from 'angular-tree-component';
import { ModalService } from 'app/core/services/modal.service';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { TopicsService } from '../topics/topics.service';
import { CustomTopicsService } from './custom-topics.service';
import { CustomTopicSubtopicAddComponent } from './custom-topic-subtopic-add/custom-topic-subtopic-add.component';

@Component({
  selector: 'itpx-custom-topics',
  templateUrl: './custom-topics.component.html',
  styleUrls: ['./custom-topics.component.css']
})
export class CustomTopicsComponent extends RxComponent implements OnInit {

  @ViewChild(TreeComponent)
  private tree: TreeComponent;

  private nodes =  [];

  options = {
      allowDrag: true,
      allowDrop: true,
      childrenField: 'nestedList'
  };

  constructor(
      private modal: ModalService,
      private modalService: SmartModalService,
      private service: CustomTopicsService
  ) {
      super();
  }

  ngOnInit() {
    this.fetch();
  }
  edit(node: TreeNode, event: any) {
      let title: string;
      if(node && (node.data.parent)) {
          title = 'Edit Subtopic'
      } else {
          title = 'Edit Topic'
      }
      this.modalService.open(<Type<Component>>CustomTopicSubtopicAddComponent,
          {...node.data}, title)
          .neverError()
        //   .map(data => {
        //       if(node && (node.data.type === 'topic')) {
        //           let nestedArr = data.result.nestedList;
        //           data.result.type = 'topic';
        //           data.result.nestedList = nestedArr && nestedArr.length ? nestedArr.map(el => {return {id: el.id }}) : [];
        //           return data.result
        //       } else {
        //           // let result = node.parent.data;
        //           // let nodeArray = node.parent.data.nested;
        //           data.result.type = 'subtopic';
        //           // result.nested = result.nested && result.nested.length ? result.nested.map(el => {return {id: el.id }}) : [];
        //           // let index = nodeArray.findIndex(el => el.id === data.result.id);
        //           // delete data.result.id;
        //           // result.nested[index] = data.result;
        //           return  data.result
        //       }
        //   })
          .flatMap(data => this.service.edit(data.result))
          .bindToLifecycle(this)
          .subscribe(
              body => {
                  this.fetch();
              }
          )
  }

  add(node: TreeNode, event: any) {
      let title: string;
      if(node && (!node.data.parent)) {
          title = 'Add Subtopic'
          this.modalService.open(<Type<Component>>CustomTopicSubtopicAddComponent, { parent: node ? node.data.code
            : null, type: 'subtopic' }, title, ModalSize.Md)
              .neverError()
              .extract('result')
            //   .map(data => {
            //       data.result.type = 'subtopic';
            //       return data.result
            //   })
              .flatMap(data => this.service.add(data))
              .map(body => {
                  let result = {
                      id: node.data.id,
                      nestedList: node.data.nestedList ? node.data.nestedList.map(el => {return {id: el.id }}) : [] };
                  result.nestedList.push({ id: body.data.id });
                  return result
              })
            //   .flatMap(data => this.service.add(data))
            //   .bindToLifecycle(this)
              .subscribe(
                  body => {
                      this.fetch();
                  }
              )
      } else {
          title = 'Add Topic'
          this.modalService.open(<Type<Component>>CustomTopicSubtopicAddComponent, { parent: node ? node.data : null, type: 'topic' }, title, ModalSize.Md)
              .neverError()
              .extract('result')
            //   .map(data => {
            //       data.result['type'] ='topic';
            //       return data.result
            //   })
              .flatMap(data => this.service.add(data))
              .bindToLifecycle(this)
              .subscribe(
                  body => {
                      this.fetch();
                  }
              )
      }

  }

  removeTopic(node: TreeNode, event: any) {
      this.modal.confirm('Delete', 'Are you sure you want to delete this topic?')
          .neverError()
          .flatMap(data => this.service.delete({id: node.data.id}))
          .bindToLifecycle(this)
          .subscribe(
              event => {
                  this.fetch();
              }
          );
  }
  removeSubtopic(node: TreeNode, event: any) {
      this.modal.confirm('Delete', 'Are you sure you want to delete this subtopic?')
          .neverError()
          .map(data => {
              let result = node.parent.data;
              let nodeArray = node.parent.data.nestedList
              let index = nodeArray.findIndex(el => el.id === node.id);
              delete result.nestedList[index];
              return result
          })
          .flatMap(data => this.service.edit(data))
          .bindToLifecycle(this)
          .subscribe(
              data => {
                  this.fetch();
              }
          );
  }

  fetch(): any {
      this.service.nestedList()
      .extract(AmberApi.Data)
          .subscribe(data => this.nodes = data)
  }

  onMoveNode(node: TreeNode, event: any) {
      const parentFrom = event.node.parent.data;
      let nodeArray = node.parent.data.nestedList
      let index = nodeArray.findIndex(el => el.id === node.id);
      delete parentFrom.nestedList[index];

      const result = event.to.parent;
      if(result.virtual) delete result.id;

      this.service.edit(parentFrom)
          .flatMap(data =>  this.service.edit(result))
          .bindToLifecycle(this)
          .subscribe(
              event => {
                  this.fetch();
              })
  }

  onCopyNode(node: any, event: any) {
      const result = event.to.parent;
      if(result.virtual) delete result.id;
      result.nestedList = result.nestedList && result.nestedList.length ? result.nestedList.map(el => {return {id: el.id }}) : [];
      this.service.edit(result)
          .bindToLifecycle(this)
          .subscribe(
              event => {
                  this.fetch();
              })
  }

}


// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/custom-topics/custom-topics.component.ts